export enum MediaPlaybackState {
  ENDED = 'ENDED',
  IDLE = 'IDLE',
  LOADING = 'LOADING',
  PAUSED = 'PAUSED',
  PLAYING = 'PLAYING',
  ERROR = 'ERROR',
}
